import React from 'react';

const Spinner = (props) => {
  let inlineSmall = false;
  if (props.inlineSmall === true) {
    inlineSmall = true;
  }
  return (
    <div className={"spinner-termovent-2023-1" + (inlineSmall ? " spinner-termovent-2023-1--inline-small" : "")}>
      <div className="spinner-rotating-fig-bg"></div>
    </div>
  );
};

export default Spinner;


/*
const Spinner = () => {
  return (
    <div className="spinner termovent-spinner">
      <div className="termovent-spinner-circle">
        <div className="border-fig"></div>
        <div className="center-fig"></div>
        <div className="termovent-spinner-t1 elisa">
          <div className="fig"></div>
        </div>
        <div className="termovent-spinner-t2 elisa">
          <div className="fig"></div>
        </div>
        <div className="termovent-spinner-t3 elisa">
          <div className="fig"></div>
        </div>

        <div className="termovent-spinner-t4 elisa">
          <div className="fig"></div>
        </div>
        <div className="termovent-spinner-t5 elisa">
          <div className="fig"></div>
        </div>
        <div className="termovent-spinner-t6 elisa">
          <div className="fig"></div>
        </div>
      </div>
    </div>
  );
};
*/
